// @flow

import React, {Component} from 'react';
import {connector} from '../store';

import ga from '../../../vendor/google-analytics';

export class StoryboardPost extends Component<any, any> {
  track: Function;

  constructor(props: any) {
    super(props);
    this.track = this.track.bind(this);
  }

  track() {
    let {show, player} = this.props;

    if (show.storyboard) {
      let label =  [
        show.title,
        player.container.fullLength ? player.container.fullLength.title : 'None',
        show.storyboard.title
      ].join(' | ');

      ga('send', 'event', 'VideoPlayer | Related Post', 'Click | [A]', label);
    }
  }

  render() {
    let storyboard = this.props.show.storyboard;

    if (storyboard) {
      return <span>
        <a className="no-delay" href={storyboard.url} onClick={this.track}>{storyboard.title}</a>
      </span>;
    }

    return '';
  }
}

export default connector(StoryboardPost);